import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
// import NavigationConfig from '../../../../navigation/config';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import { useDispatch } from 'react-redux';

interface IProps {
  reimburse_info_mscon_id: number;
  iban: string;
  bic: string;
  vat_amount_to_be_reimbursed: number;
  reimbursement_date: Date;
  status: number;
}

export default function ActionsBlock(props: IProps) {
  // const history = useHistory();
  // const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();

  const editReimburseInfo = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_UPDATE_REIMBURSE_INFO_MSCON,
        params: {
          reimburse_info_mscon_id: props.reimburse_info_mscon_id,
          iban: props.iban,
          bic: props.bic,
          vat_amount_to_be_reimbursed: props.vat_amount_to_be_reimbursed,
          reimbursement_date: props.reimbursement_date,
        },
      })
    );
  };

  return (
    <div>
      <Button disabled={props.status === 1} onClick={() => editReimburseInfo()}>
        REIMBURSE
      </Button>
      {/* <Button></Button> */}
    </div>
  );
}
